import { TextField, TextFieldProps } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import React from 'react';
import { useController, useFormContext, RegisterOptions } from 'react-hook-form';

type FormTextFieldProps = TextFieldProps & {
  name: string;
  rules?: RegisterOptions;
  disableFuture?: boolean;
};

const FormDatePicker = ({ name, rules, disableFuture = false, ...props }: FormTextFieldProps) => {
  const { field } = useController<Record<string, number>>({ name, rules });
  const {
    formState: { errors },
    setValue,
  } = useFormContext();
  const error = errors[name];

  return (
    <DatePicker
      value={field.value}
      onChange={(newValue: Date | null) => setValue(name, newValue?.getTime() || Date.now())}
      renderInput={(params) => (
        <TextField
          {...params}
          required={Boolean(rules?.required)}
          error={Boolean(error)}
          color="info"
          fullWidth
          {...props}
        />
      )}
      disableFuture={disableFuture}
    />
  );
};

export default FormDatePicker;
